import { useEffect } from 'react'
import { useForm } from './controller'

const Toucher = ({ name }) => {
    const { triggerChange } = useForm()
    useEffect(() => triggerChange(name, { touched: true }), [])
    return null
}

export default Toucher